import angular from 'angular'
import MarkdownEdit from 'emun.markdown/markdown-edit'
import MarkdownsList from 'emun.markdown/markdowns-list'

const dependencies = ['emun.auth', 'webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('emun.markdown', dependencies)
.component('markdownEdit', MarkdownEdit)
.component('markdownsList', MarkdownsList)
.name;